// src/belediye/components/mesajlasma/TaskLauncher.js
// G1: Kişi seçildikten sonra açılan "sohbet-ekranı" — serbest yazı YOK (mesaj
// kutusu hiç görünmez). İşlemler SEÇENEKLİ panelle (AskUserQuestion tarzı) başlar:
// Hızlı Görev (daha hızlı → AYRI renk) · Görev Ata · Başvuru Ata. Seçim →
// NewChatPanel taskMode → TaskComposer (adım adım sorular).
// Not: kök class `msj-tasklauncher` — ChatDock'un `.msj-launcher` FAB'ı ile
// çakışmasın diye özel önek (FAZ-41 dersi).
import React from "react";
import {
  ArrowLeftIcon,
  ArrowRightIcon,
  BoltIcon,
} from "@heroicons/react/24/outline";

// FAZ-51: görev ikonu TEK sözlükten (kavram değişince her yer değişsin)
import { ApplicationIcon, TaskIcon } from "../icons/appIcons";

import usePermissions from "../../hooks/usePermissions";
import useMsjFeatures from "./useMsjFeatures";

export default function TaskLauncher({ targets = [], unitTarget = null, onPickMode, onBack }) {
  const { can } = usePermissions();
  const features = useMsjFeatures();

  const atamaIzni = unitTarget ? can("tasks.assign_to_unit") : can("tasks.assign_to_user");
  const gorevChip = features.gorev && can("tasks.create") && atamaIzni;

  // FAZ-52: başvuru akışı YAZILDI (kullanıcı kararı 2026-07-27 — "mevcut
  // başvuruyu ata"). FAZ-49'daki geçici kod kilidi (BASVURU_AKISI_HAZIR)
  // kaldırıldı; artık tek kapı özellik bayrağı + atama izni.
  //
  // Kural (kullanıcı): başvuru özelliği KAPALIYSA burada başvuru seçeneği HİÇ
  // görünmez (sohbet listesindeki "Başvurular" sekmesi de öyle). Yalnız görev
  // açıksa geriye Hızlı Görev + Görev Ata kalır.
  //
  // İzin: `assignments.create` — başvuru ATAMA yetkisi. `tasks.create` DEĞİL:
  // başvuru atamak görev oluşturmaktan ayrı bir iştir; ikisini aynı izne
  // bağlamak, görev veremeyen ama başvuru dağıtan personeli dışarıda bırakırdı.
  //
  // Birim hedefinde başvuru YOK: atama modeli tek kişi tutar (assigned_to).
  const basvuruChip = features.basvuru && !unitTarget && can("assignments.create");

  const names =
    [
      ...targets.map((t) => t.display_name),
      ...(unitTarget ? [`${unitTarget.name} (birimin tümü)`] : []),
    ].join(", ") || "seçili kişiler";

  return (
    <div className="msj-tasklauncher">
      <div className="msj-tasklauncher-head">
        <button type="button" className="msj-iconbtn" onClick={onBack} aria-label="Geri">
          <ArrowLeftIcon width={20} />
        </button>
        <span className="msj-tasklauncher-kime">
          Kime: <b>{names}</b>
          {targets.length > 1 && " (ilki sorumlu)"}
        </span>
      </div>

      {/* Serbest mesaj YOK — yalnız seçenekli işlem paneli. */}
      <div className="msj-wq" role="group" aria-label="İşlem seç">
        <div className="msj-wq-head">
          <span className="msj-wq-title">Ne yapmak istiyorsunuz?</span>
        </div>
        <ul className="msj-wq-options">
          {gorevChip && (
            <li>
              <button
                type="button"
                className="msj-wq-opt msj-wq-opt--hizli"
                onClick={() => onPickMode("hizli")}
              >
                <span className="msj-wq-num" aria-hidden="true"><BoltIcon /></span>
                <span className="msj-wq-lbl">
                  Hızlı Talep
                  <span className="msj-wq-hint">Tek adımda, hızlıca talep gönder</span>
                </span>
                <ArrowRightIcon className="msj-wq-go" />
              </button>
            </li>
          )}
          {gorevChip && (
            <li>
              <button
                type="button"
                className="msj-wq-opt"
                onClick={() => onPickMode("detayli")}
              >
                <span className="msj-wq-num" aria-hidden="true"><TaskIcon /></span>
                <span className="msj-wq-lbl">
                  Talep Gönder
                  <span className="msj-wq-hint">Başlık + açıklama ile detaylı talep</span>
                </span>
                <ArrowRightIcon className="msj-wq-go" />
              </button>
            </li>
          )}
          {basvuruChip && (
            <li>
              <button
                type="button"
                className="msj-wq-opt"
                onClick={() => onPickMode("basvuru")}
              >
                <span className="msj-wq-num" aria-hidden="true"><ApplicationIcon /></span>
                <span className="msj-wq-lbl">
                  Başvuru Ata
                  <span className="msj-wq-hint">Mevcut bir başvuruyu bu kişiye ver</span>
                </span>
                <ArrowRightIcon className="msj-wq-go" />
              </button>
            </li>
          )}
        </ul>
      </div>
    </div>
  );
}
